import React from 'react';
import { filter, includes } from 'lodash';
import enhance from './InfluencerList.enhancer';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LinkText from '../../../components/shared/components/LinkText';
import { getCountryValueFromKey } from '../../../helpers/countryHelper';
import StarRatings from 'react-star-ratings';
import SearchIcon from '@material-ui/icons/Search';
import Toolbar from '@material-ui/core/Toolbar';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import Autosuggest from 'react-autosuggest';
import { findDOMNode } from 'react-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import RootRef from '@material-ui/core/RootRef';
import { industrySelections } from '../../../constants';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInputBox from '../../../components/shared/components/OutlinedInputBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import Fab from '@material-ui/core/Fab';
import SendCampaignMatchPopup from '../../shared/components/SendCampaignMatchPopup';
import Popover from '@material-ui/core/Popover';
import { dealStatuses } from '../../../constants';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AgeRangeSelector from './AgeRangeSelector';
import { countries } from '../../../constants';

import { RadioIcon, RadioFillIcon, grey, primary } from '../../../style';

class InfluencerList extends React.Component {
  constructor() {
    super();

    this.initialState = {
      rowsLoaded: false,
      tableRows: [],
      allRowsLoaded: false,
      searchValue: '',
      suggestions: [],
      loadingMoreInfluencers: false,
      filtersShown: false,
      filterTitleHeight: 0,
      filters: {
        gender: 'All',
        ageMin: '',
        ageMax: '',
        industry: 'All',
        audienceGender: 'All',
        audienceAgeRange: 'All',
        audienceCountry: 'All'
      },
      campaignMatchPopupOpen: false,
      campaignMatchPopupTarget: null,
      campaignSelection: null,
      influencerMatchSelection: null
    };

    this.state = {
      ...this.initialState
    };

    this.filterTitleRef = React.createRef();
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.loadInfluencers();
    this.setState({
      filterTitleHeight: this.filterTitleRef.current.offsetHeight
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const windowHeight =
      'innerHeight' in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (windowBottom >= docHeight) {
      this.loadMoreInfluencers();
    }
  }

  createLoadInfluencerPromises = influencerDocs => {
    return influencerDocs.map((influencerDoc, index) => {
      const influencerData = influencerDoc.data();
      if (index === influencerDocs.length - 1) {
        this.setState({
          lastLoadedInfluencer: influencerDocs[index]
        });
      }
      return {
        ...influencerData,
        country: getCountryValueFromKey(influencerData.country),
        id: influencerDoc.id
      };
    });
  };

  searchTags = () => {
    this.setState({
      rowsLoaded: false,
      tableRows: [],
      allRowsLoaded: false
    });

    this.loadInfluencers();
  };

  loadInfluencers() {
    let query = this.props.firestore.collection('users');
    query = this.applyAgeFilter(query);
    query = query
      .orderBy('youtube.subscribers', 'desc')
      .where('status', '==', 'ACTIVE')
      .where('isCompany', '==', false);

    query = this.applyFilters(query);

    query
      .limit(20)
      .get()
      .then(influncersSnapshot => {
        if (!influncersSnapshot.docs.length) {
          this.setState({
            allRowsLoaded: true,
            influencers: []
          });
        } else {
          const influencers = this.createLoadInfluencerPromises(
            influncersSnapshot.docs
          );
          this.setState({
            tableRows: influencers
          });
        }
      });
  }

  loadMoreInfluencers() {
    if (
      this.state.lastLoadedInfluencer &&
      !this.state.allRowsLoaded &&
      !this.state.loadingMoreInfluencers
    ) {
      this.setState({
        loadingMoreInfluencers: true
      });
      let query = this.props.firestore.collection('users');
      query = this.applyAgeFilter(query);
      query = query
        .orderBy('youtube.subscribers', 'desc')
        .where('status', '==', 'ACTIVE')
        .where('isCompany', '==', false)
        .startAfter(this.state.lastLoadedInfluencer);

      query = this.applyFilters(query);

      query
        .limit(20)
        .get()
        .then(influncersSnapshot => {
          if (!influncersSnapshot.docs.length) {
            this.setState({
              allRowsLoaded: true,
              loadingMoreInfluencers: false
            });
          } else {
            const influencers = this.createLoadInfluencerPromises(
              influncersSnapshot.docs
            );
            this.setState({
              tableRows: [...this.state.tableRows, ...influencers],
              loadingMoreInfluencers: false
            });
          }
        });
    }
  }

  applyAgeFilter = query => {
    if (this.state.filters.ageMin || this.state.filters.ageMax) {
      query = query.orderBy('age');
      //apply age min
      if (this.state.filters.ageMin) {
        query = query.where('age', '>', this.state.filters.ageMin);
      }

      //apply age max
      if (this.state.filters.ageMax) {
        query = query.where('age', '<', this.state.filters.ageMax);
      }
    }

    return query;
  };

  applyFilters = query => {
    // apply tag search
    if (this.state.searchValue) {
      query = query.where(
        'interests',
        'array-contains',
        this.state.searchValue
      );
    }

    // apply gender
    if (this.state.filters.gender && this.state.filters.gender !== 'All') {
      query = query.where('gender', '==', this.state.filters.gender);
    }

    //apply industry
    if (this.state.filters.industry && this.state.filters.industry !== 'All') {
      query = query.where('industry', '==', this.state.filters.industry);
    }

    if (
      this.state.filters.audienceGender &&
      this.state.filters.audienceGender !== 'All'
    ) {
      query = query.where(
        'youtube.demographics.ageAndGenderDemographics.topGender',
        '==',
        this.state.filters.audienceGender
      );
    }

    if (
      this.state.filters.audienceAgeRange &&
      this.state.filters.audienceAgeRange !== 'All'
    ) {
      query = query.where(
        'youtube.demographics.ageAndGenderDemographics.topLowerAge',
        '==',
        this.state.filters.audienceAgeRange
      );
    }

    if (
      this.state.filters.audienceCountry &&
      this.state.filters.audienceCountry !== 'All'
    ) {
      query = query.where(
        'youtube.demographics.countryDemographics.topCountry',
        '==',
        this.state.filters.audienceCountry
      );
    }

    return query;
  };

  filterButtonClick = () => {
    this.setState({
      rowsLoaded: false,
      tableRows: [],
      allRowsLoaded: false
    });

    this.loadInfluencers();
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    const suggestions = filter(this.props.influencerTags, tag =>
      includes(tag.toLowerCase(), value.toLowerCase())
    );
    this.setState({ suggestions });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  navigateToInfluencer = userId => {
    this.props.history.push(`/user/${userId}/profile`);
  };

  getSuggestionValue = suggestion => suggestion;

  renderSuggestion = suggestion => (
    <div style={{ cursor: 'pointer' }}>{suggestion}</div>
  );

  onSuggestionSelected = selection => {
    this.setState({
      searchValue: selection.target.textContent
    });
  };

  onSearchChange = e => {
    this.setState({
      searchValue: e.target.value ? e.target.value : e.target.textContent
    });
  };

  handleFiltersClick() {
    this.setState(prevState => ({
      filtersShown: !prevState.filtersShown
    }));
  }

  changeFilterHandler = e => {
    this.setState({
      filters: {
        ...this.state.filters,
        [e.target.name]: e.target.value
      }
    });
  };

  ageMinChangeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        ageMin: parseInt(e.target.value)
      }
    });
  }

  ageMaxChangeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        ageMax: parseInt(e.target.value)
      }
    });
  }

  audienceGenderChangeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        audienceGender: e.target.value
      }
    });
  }

  audienceAgeRangeChangeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        audienceAgeRange: e.target.value
      }
    });
  }

  openSendMatchPopup = (influencer, event) => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      ...this.state,
      campaignMatchPopupTarget: event.target,
      influencerMatchSelection: influencer,
      campaignMatchPopupOpen: true
    });
    return false;
  };

  openProposeDeal = (influencer, event) => {
    if (!this.props.activeCampaigns.length) {
      this.props.showNoActiveCampaignsNotification();
    } else {
      // check if the company has multiple active campaigns - if so they have to select which one
      if (this.props.activeCampaigns.length > 1) {
        this.openSendMatchPopup(influencer, event);
      } else {
        const campaign = this.props.campaign
          ? this.props.campaign
          : this.props.activeCampaigns[0];
        this.proposeDealForCampaign(influencer, campaign);
      }
    }
  };

  proposeDealForCampaign = (influencer, campaign) => {
    // check if there is a deal with this campaign and
    // TODO: THIS ISNT WORKING
    const existingActiveDeals = this.props.deals.filter(
      deal =>
        deal.campaignId === campaign.id &&
        deal.influencerId === influencer.id &&
        deal.status !== dealStatuses.COMPLETE
    );
    if (!existingActiveDeals.length) {
      this.props.proposeDealClick(influencer, campaign);
    } else {
      this.props.showAlreadyMatchedNotification();
    }
  };

  closeSendMatchPopup = event => {
    event.stopPropagation();
    event.preventDefault();
    return this.setState({
      ...this.state,
      campaignMatchPopupOpen: false,
      campaignMatchPopupTarget: null,
      campaignSelection: null,
      influencerMatchSelection: null
    });
  };

  selectCampaignForProposal() {
    if (this.state.campaignSelection) {
      this.proposeDealForCampaign(
        this.state.influencerMatchSelection,
        this.state.campaignSelection
      );

      this.setState({
        ...this.state,
        campaignMatchPopupOpen: false,
        campaignMatchPopupTarget: null,
        campaignSelection: null,
        influencerMatchSelection: null
      });
    }
  }

  campaignChangeHandler(e) {
    this.setState({
      ...this.state,
      campaignSelection: e.target.value
    });
  }

  render() {
    const { classes, campaign, activeCampaigns, proposeDealClick } = this.props;
    const {
      tableRows,
      allRowsLoaded,
      searchValue,
      suggestions,
      loadingMoreInfluencers,
      filtersShown,
      filterTitleHeight,
      filters,
      campaignMatchPopupOpen,
      campaignMatchPopupTarget,
      campaignSelection,
      influencerMatchSelection
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          {!campaign && (
            <Grid
              className={classes.header}
              container
              direction="row"
              justify="space-between"
              alignItems="flex-end"
            >
              <Grid item>
                <Typography
                  variant="h3"
                  id="tableTitle"
                  className={classes.title}
                >
                  Discover
                </Typography>
              </Grid>
            </Grid>
          )}
          <Paper className={classes.root}>
            <Toolbar className={classes.filterToolbar}>
              <Grid container direction="column" className={classes.space}>
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item sm={4} xs={12}>
                        <FormControl className={classes.search}>
                          <Box color="text.hint">
                            <SearchIcon />
                          </Box>
                          <Autosuggest
                            className={classes.searchBox}
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={
                              this.onSuggestionsFetchRequested
                            }
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(
                              this
                            )}
                            getSuggestionValue={this.getSuggestionValue}
                            onSuggestionSelected={this.onSuggestionSelected.bind()}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={{
                              placeholder: 'Search influencer tags...',
                              value: searchValue,
                              onChange: this.onSearchChange.bind(this)
                            }}
                            theme={{
                              input: classes.reactAutosuggestInput,
                              container: classes.reactAutosuggestContainer,
                              inputFocused:
                                classes.reactAutosuggestInputFocused,
                              inputOpen: classes.reactAutosuggestInputOpen,
                              suggestionsContainer:
                                classes.reactAutosuggestSuggestionsContainer,
                              suggestionsContainerOpen:
                                classes.reactAutosuggestSuggestionsContainerOpen,
                              suggestionsList:
                                classes.reactAutosuggestSuggestionsList,
                              suggestion: classes.ReactAutosuggestSuggestion,
                              suggestionHighlighted:
                                classes.reactAutosuggestSuggestionHighlighted
                            }}
                          />
                          {/* </InputBase> */}
                        </FormControl>
                      </Grid>
                      <Grid item sm={2} xs={12}>
                        <Button
                          variant="outlined"
                          className={classes.searchButton}
                          onClick={() => this.searchTags()}
                        >
                          Search Tags
                        </Button>
                      </Grid>
                      <Grid item sm={4} xs={12}>
                        <Button
                          variant="outlined"
                          className={classes.filterButton}
                          onClick={() => this.handleFiltersClick()}
                        >
                          {filtersShown ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                        {filtersShown && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.applyFilterButton}
                            onClick={this.filterButtonClick.bind(this)}
                          >
                            Apply Filters
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <ExpansionPanel
                      className={classes.expandPanel}
                      expanded={filtersShown}
                    >
                      <ExpansionPanelSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      />
                      <ExpansionPanelDetails>
                        <Grid container direction="column">
                          <Grid container direction="row" spacing={2}>
                            <Grid container item direction="column" sm={4}>
                              <Box>
                                <RootRef rootRef={this.filterTitleRef}>
                                  <Typography>CONTENT TYPE</Typography>
                                </RootRef>
                              </Box>
                              <TextField
                                id="industry"
                                name="industry"
                                select
                                onChange={this.changeFilterHandler}
                                className={classes.select}
                                InputProps={{
                                  classes: { input: classes.input1 }
                                }}
                                SelectProps={{
                                  classes: {
                                    root: classes.selectRoot,
                                    select: classes.select2
                                  }
                                }}
                                margin="normal"
                                variant="outlined"
                                value={filters.industry}
                              >
                                {['All', ...industrySelections].map(
                                  (item, i) => (
                                    <MenuItem key={i} value={item}>
                                      {item}
                                    </MenuItem>
                                  )
                                )}
                              </TextField>
                            </Grid>
                            <Grid container item direction="column" sm={4}>
                              <Box>
                                <RootRef rootRef={this.filterTitleRef}>
                                  <Typography>CREATOR'S GENDER</Typography>
                                </RootRef>
                              </Box>
                              <TextField
                                id="gender"
                                name="gender"
                                select
                                onChange={this.changeFilterHandler}
                                className={classes.select}
                                InputProps={{
                                  classes: { input: classes.input1 }
                                }}
                                SelectProps={{
                                  classes: {
                                    root: classes.selectRoot,
                                    select: classes.select2
                                  }
                                }}
                                margin="normal"
                                variant="outlined"
                                value={filters.gender}
                              >
                                {['All', 'Male', 'Female'].map((item, i) => (
                                  <MenuItem key={i} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            <Grid container item direction="column" sm={4}>
                              <Box>
                                <RootRef rootRef={this.filterTitleRef}>
                                  <Typography>CREATOR'S AGE</Typography>
                                </RootRef>
                              </Box>
                              <div>
                                <OutlinedInputBox
                                  id="min"
                                  name="ageMin"
                                  variant="outlined"
                                  value={this.state.filters.ageMin}
                                  onChange={this.ageMinChangeHandler.bind(this)}
                                  type="number"
                                />
                                <Typography variant="body1" align="center">
                                  To
                                </Typography>
                                <OutlinedInputBox
                                  id="max"
                                  name="ageMax"
                                  variant="outlined"
                                  value={this.state.filters.ageMax}
                                  onChange={this.ageMaxChangeHandler.bind(this)}
                                  type="number"
                                />
                              </div>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            direction="row"
                            spacing={2}
                            className={classes.creatorFiltersRow}
                          >
                            <Grid container item direction="column" sm={4}>
                              <Box>
                                <RootRef rootRef={this.filterTitleRef}>
                                  <Typography>TOP AUDIENCE GENDER</Typography>
                                </RootRef>
                              </Box>
                              <RadioGroup
                                aria-label="genderRadioGroup"
                                name="genderSelector"
                                className={classes.radioGroup}
                                onChange={this.audienceGenderChangeHandler.bind(
                                  this
                                )}
                                value={filters.audienceGender}
                              >
                                <FormControlLabel
                                  value="All"
                                  control={
                                    <Radio
                                      color="primary"
                                      icon={<RadioIcon htmlColor={'white'} />}
                                      checkedIcon={
                                        <RadioFillIcon htmlColor={'white'} />
                                      }
                                    />
                                  }
                                  label="Any Gender"
                                  labelPlacement="end"
                                />
                                <FormControlLabel
                                  value="male"
                                  control={
                                    <Radio
                                      color="primary"
                                      icon={<RadioIcon htmlColor={'white'} />}
                                      checkedIcon={
                                        <RadioFillIcon htmlColor={'white'} />
                                      }
                                    />
                                  }
                                  label="Male"
                                  labelPlacement="end"
                                />
                                <FormControlLabel
                                  value="female"
                                  control={
                                    <Radio
                                      color="primary"
                                      icon={<RadioIcon htmlColor={'white'} />}
                                      checkedIcon={
                                        <RadioFillIcon htmlColor={'white'} />
                                      }
                                    />
                                  }
                                  label="Female"
                                  labelPlacement="end"
                                />
                              </RadioGroup>
                            </Grid>
                            <Grid container item direction="column" sm={4}>
                              <Box>
                                <RootRef rootRef={this.filterTitleRef}>
                                  <Typography>TOP AUDIENCE AGE</Typography>
                                </RootRef>
                              </Box>
                              <AgeRangeSelector
                                ageRangeChangeHandler={this.audienceAgeRangeChangeHandler.bind(
                                  this
                                )}
                                ageRange={filters.ageRange}
                              />
                            </Grid>
                            <Grid container item direction="column" sm={4}>
                              <Box>
                                <RootRef rootRef={this.filterTitleRef}>
                                  <Typography>TOP AUDIENCE COUNTRY</Typography>
                                </RootRef>
                              </Box>
                              <TextField
                                id="audienceCountry"
                                name="audienceCountry"
                                select
                                onChange={this.changeFilterHandler}
                                className={classes.select}
                                InputProps={{
                                  classes: { input: classes.input1 }
                                }}
                                SelectProps={{
                                  classes: {
                                    root: classes.selectRoot,
                                    select: classes.select2
                                  }
                                }}
                                margin="normal"
                                variant="outlined"
                                value={filters.audienceCountry}
                              >
                                {countries.map((item, i) => (
                                  <MenuItem key={i} value={item.value}>
                                    {item.value}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          </Grid>
                        </Grid>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </Grid>
                </Grid>
              </Grid>
            </Toolbar>
            <Grid>
              {tableRows &&
                tableRows.map(row => (
                  <Grid
                    key={row.id}
                    className={classes.listRow}
                    container
                    direction="row"
                  >
                    <Grid item className={classes.pictureLink}>
                      <Box
                        mr={2}
                        onClick={() =>
                          window.open(
                            `${process.env.REACT_APP_BASE_URL}user/${row.id}/profile`,
                            '_blank'
                          )
                        }
                      >
                        <img
                          src={row.profilePictureUrl}
                          className={classes.circleImage}
                        />
                      </Box>
                    </Grid>
                    <Grid item container direction="column" sm xs={12}>
                      <Grid container direction="row">
                        <Grid xs={12} sm={6}>
                          <Grid container direction="row">
                            <Grid md={6} xs={12}>
                              <Box pr={1}>
                                <LinkText
                                  onClick={() =>
                                    window.open(
                                      `${process.env.REACT_APP_BASE_URL}user/${row.id}/profile`,
                                      '_blank'
                                    )
                                  }
                                >
                                  <Typography variant="h5">
                                    {row.displayName}
                                  </Typography>
                                </LinkText>
                              </Box>
                            </Grid>
                            <Grid xs={12} sm={6}>
                              <Typography>
                                <Box color="text.secondary">
                                  <LocationOnIcon />
                                  {row.country}
                                </Box>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          className={classes.starRatings}
                          xs={12}
                          sm={6}
                        >
                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.matchButton}
                            onClick={event => {
                              event.stopPropagation();
                              event.preventDefault();
                              // this.openSendMatchPopup(row.id, event);
                              this.openProposeDeal(row, event);
                            }}
                          >
                            Propose Deal
                          </Button>
                          {/* </div> */}
                        </Grid>
                      </Grid>
                      <Grid />
                      <Grid className={classes.interestContainer}>
                        {row.interests &&
                          row.interests.length > 0 &&
                          row.interests
                            .slice(0, 3)
                            .map((interest, index) => (
                              <span className={classes.interest}>
                                {interest}
                              </span>
                            ))}
                      </Grid>
                      <Grid className={classes.youtubeContainer}>
                        <Fab
                          size="small"
                          color="secondary"
                          aria-label="youtube"
                        >
                          <FontAwesomeIcon
                            className={classes.youtubeIcon}
                            icon={faYoutube}
                          />
                        </Fab>
                        <Typography
                          display="inline"
                          className={classes.youtubeStatTitle}
                        >
                          Subscribers:{' '}
                        </Typography>
                        <Typography
                          display="inline"
                          className={classes.youtubeStat}
                        >
                          {row.youtube
                            ? row.youtube.subscribers.toLocaleString()
                            : 0}
                        </Typography>
                        <Typography
                          display="inline"
                          className={classes.youtubeStatTitle}
                        >
                          Average Views:{' '}
                        </Typography>
                        <Typography
                          display="inline"
                          className={classes.youtubeStat}
                        >
                          {row.youtube
                            ? row.youtube.averageViews.toLocaleString()
                            : 0}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        direction="row"
                        className={classes.descriptionContainer}
                      >
                        <Box color="text.hint">{row.description}</Box>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
            </Grid>
          </Paper>
          <Typography align="center" className={classes.loadMoreTextContainer}>
            {!allRowsLoaded && (
              <div
                className={classes.loadMoreText}
                onClick={this.loadMoreInfluencers.bind(this)}
              >
                Load More
              </div>
            )}
            {allRowsLoaded && <div>End of Results</div>}
          </Typography>
          {!allRowsLoaded && (
            <ArrowDownwardIcon className={classes.downArrow} />
          )}
          {loadingMoreInfluencers && (
            <CircularProgress className={classes.downArrow} />
          )}
        </main>
        <SendCampaignMatchPopup
          open={campaignMatchPopupOpen}
          campaignMatchPopupTarget={campaignMatchPopupTarget}
          onClose={this.closeSendMatchPopup.bind(this)}
          campaigns={activeCampaigns}
          campaignChangeHandler={this.campaignChangeHandler.bind(this)}
          campaignSelection={campaignSelection}
          selectCampaignForProposal={this.selectCampaignForProposal.bind(this)}
        />
      </React.Fragment>
    );
  }
}

export default enhance(InfluencerList);



// WEBPACK FOOTER //
// ./src/components/company/discover-influencers/InfluencerList.js